import { render, staticRenderFns } from "./NewsDetailCruiseList.vue?vue&type=template&id=40cbcaee&scoped=true"
import script from "./NewsDetailCruiseList.vue?vue&type=script&lang=js"
export * from "./NewsDetailCruiseList.vue?vue&type=script&lang=js"
import style0 from "./NewsDetailCruiseList.vue?vue&type=style&index=0&id=40cbcaee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cbcaee",
  null
  
)

export default component.exports